export default [
    {
        thumbnail: 'https://img001.aivideo8.com/ai_video/thumbnailWord/449/2021-03-05/1614910198538.png?x-oss-process=image/resize,w_400',
        params: {
            text: 'Product Name',
            top: 0,
            left: 0,
            width: 538,
            height: 302,
            rotate: 0,
            opacity: 100,
            fontSize: 120,
            fontFamily: 'Montserrat-ExtraBoldItalic',
            autoFontSize: true,
            color: '#fff',
            useShadow: true,
            shadow: {
                x: 0,
                y: 4,
                blur: 9,
                color: 'rgba(0,0,0,.4)'
            },
            align: 'center',
            lineHeight: 1.25,
            stroke: '#49e',
            strokeWidth: 16,
            strokeGradient: {
                type: 'linear',
                x1: 0,
                x2: 1,
                y1: 0,
                y2: 1,
                stops: [
                    { offset: 0, color: '#22aaff' },
                    { offset: 92, color: '#fc7fde' }
                ]
            },
            verticalAlign: 'middle',
            letterSpacing: 0
        }
    },
    {
        thumbnail: 'https://img001.aivideo8.com/ai_video/thumbnailWord/449/2021-03-05/1614910378528.png?x-oss-process=image/resize,w_400',
        params: {
            text: 'Product Name',
            top: 0,
            left: 0,
            width: 536,
            height: 302,
            rotate: 0,
            opacity: 100,
            fontSize: 120,
            fontFamily: 'Ubuntu-BI',
            autoFontSize: true,
            color: '#ff6aad',
            useShadow: true,
            shadow: {
                x: 0,
                y: 2,
                blur: 6,
                color: 'rgba(0,0,0,.3)'
            },
            align: 'center',
            lineHeight: 1.25,
            stroke: '#fff',
            strokeWidth: 16,
            verticalAlign: 'middle',
            letterSpacing: 0
        }
    },
    {
        thumbnail: 'https://img001.aivideo8.com/ai_video/thumbnailWord/449/2021-03-05/1614910510307.png?x-oss-process=image/resize,w_400',
        params: {
            text: 'Product Name',
            top: 0,
            left: 0,
            width: 818,
            height: 170,
            rotate: 0,
            opacity: 100,
            fontSize: 120,
            fontFamily: 'HKGrotesk-ExtraBold',
            autoFontSize: true,
            color: '#fff',
            background: 'rgba(0,0,0,.5)',
            useShadow: false,
            shadow: {
                x: 0,
                y: 3,
                blur: 8,
                color: 'rgba(0,0,0,.3)'
            },
            align: 'center',
            lineHeight: 1.4,
            stroke: '#49e',
            strokeWidth: 0,
            verticalAlign: 'middle',
            letterSpacing: 0
        }
    },
    {
        thumbnail: 'https://img001.aivideo8.com/ai_video/thumbnailWord/449/2021-03-05/1614910618248.png?x-oss-process=image/resize,w_400',
        params: {
            text: 'Product Name',
            top: 0,
            left: 0,
            width: 883,
            height: 132,
            rotate: 0,
            opacity: 100,
            fontSize: 100,
            fontFamily: 'georgiab',
            autoFontSize: true,
            color: '#131415',
            background: '#E95B23',
            useShadow: false,
            shadow: {
                x: 0,
                y: 3,
                blur: 8,
                color: 'rgba(0,0,0,.3)'
            },
            align: 'center',
            lineHeight: 1.3,
            stroke: '#49e',
            strokeWidth: 0,
            verticalAlign: 'middle',
            letterSpacing: 0
        }
    },
    {
        thumbnail: 'https://img001.aivideo8.com/ai_video/thumbnailWord/449/2021-03-05/1614910711298.png?x-oss-process=image/resize,w_400',
        params: {
            text: 'Product',
            top: 0,
            left: 0,
            width: 532,
            height: 132,
            rotate: 0,
            opacity: 100,
            fontSize: 100,
            fontFamily: 'Montserrat-ExtraBoldItalic',
            autoFontSize: true,
            color: '#FAFFFE',
            background: '#FB0A01',
            useShadow: false,
            shadow: {
                x: 0,
                y: 3,
                blur: 8,
                color: 'rgba(0,0,0,.3)'
            },
            align: 'center',
            lineHeight: 1.3,
            stroke: '#49e',
            strokeWidth: 0,
            verticalAlign: 'middle',
            letterSpacing: 0
        }
    },
    {
        thumbnail: 'https://img001.aivideo8.com/ai_video/thumbnailWord/449/2021-03-05/1614910799338.png?x-oss-process=image/resize,w_400',
        params: {
            text: 'Product Name',
            top: 0,
            left: 0,
            width: 928,
            height: 182,
            rotate: 0,
            opacity: 100,
            fontSize: 144,
            fontFamily: 'Montserrat-ExtraBold',
            autoFontSize: true,
            color: '#FAFFFE',
            useShadow: true,
            shadow: {
                x: 0,
                y: 11,
                blur: 22,
                color: '#004751'
            },
            align: 'center',
            lineHeight: 1.25,
            stroke: '#49e',
            strokeWidth: 0,
            verticalAlign: 'middle',
            letterSpacing: 0
        }
    }
];